import BSelect from "@/components/b-select.jsx"
import BInput from "@/components/b-input.jsx"
import Paging from "@/components/paging.jsx";
import dayjs from "dayjs";
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import http from "@/http"
import { use, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
export default function NoticeDetail() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate()
  const id = queryParams.get('id');
  const [detail, setDetail] = useState({})
  const { t } = useTranslation();
  useEffect(() => {
    http.get('/system/nftNotice/' + id).then(res => {
      setDetail(res)
    })
  }, [id])
  return <div>
    <div className="title-tool">
      <h2 className="page-title cursor-pointer" onClick={() => navigate(-1)}>
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.9046 26.1725L10.6963 16.9642L19.9046 7.75586L22.5255 10.3767L15.938 16.9642L22.5255 23.5517L19.9046 26.1725Z" fill="#2B2B2B" />
        </svg>
        {t('announcement.news_title')}
      </h2>
    </div>
    <div className="notice-detail">
      <div className="notice-head">
        <div className="title">{detail.title}</div>
        <div className="data">
          <div>{t('announcement.date_posted')} <span>{dayjs(detail.createTime).format('YY.MM.DD HH:mm:ss')}</span></div>
          <div>{t('announcement.Views')} <span>{detail.click}</span></div>
        </div>
      </div>
      <div className="notice-detail-content" dangerouslySetInnerHTML={{ __html: detail.content }}>
      </div>
    </div>
    <button className="cs-btn cs-style1" style={{ borderRadius: "10px", float: "right", marginTop: "20px" }}><span style={{ position: "relative" }} onClick={() => navigate(-1)}>{t('announcement.List')}</span></button>
  </div >
}